<template>
  <div class="map-school-card" v-if="!isEmptySchools">
    <div class="map-school-card-header d-flex">
      <img
        :src="`/images/markers/${type}.svg`"
        width="20"
        height="19"
        alt="marker"
      />
      <div class="map-school-card-header__city">
        {{ schools.city[selectedIndex] }}
      </div>
      <div class="ml-auto">
        <CardNavigation
          :length="schools.id.length"
          :current="selectedIndex"
          @forward="nextSchool"
          @back="previousSchool"
        />
      </div>
    </div>
    <hr class="map-school-card-hr" />
    <div
      class="map-school-card-body d-flex overflow-hidden flex-wrap"
      :style="{ height: heightBody }"
    >
      <div class="map-school-card-body__school"
        v-for="(schoolId, index) in schools.id"
        :key="schoolId"
        :class="schoolId === schools.id[selectedIndex] ? 'current-school' : 'hidden-school'"
      >
        <a v-if="type === 'fields'"
         class="map-school-card-body__title"
         :href="schools.siteUrl[index]"
         target="_blank"
        >
          {{ schools.name[index] }}
        </a>
        <router-link v-else
          class="map-school-card-body__title"
          :to="linkPrefix + schools.id[index]"
          target="_blank"
        >
          {{ schools.name[index] }}
        </router-link>
        <div class="map-school-card-body__address">
          {{ schools.address[index] }}
        </div>
        <div
          class="map-school-card-body__org"
          v-if="schools.orgNames.length && schools.orgNames[index].length"
        >
          <strong v-if="!(schools.orgNames[index].length === 1
          && schools.orgNames[index][0] === null)">Организация: </strong>
          <span v-for="(name, indexName) of schools.orgNames[index]" :key="indexName">
            <a
              class="map-school-card-body__org-site"
              :href="schools.orgSites[index][indexName]"
              target="_blank"
            >
              {{ name }}
            </a>
            <span v-if="indexName !== schools.orgNames[index].length - 1">, </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import CardNavigation from '@/components/main-page/map/CardNavigation.vue'

export default {
  name: 'MapSchoolCard',
  components: { CardNavigation },
  props: {
    schools: {
      type: Object,
      default() {
        return null
      }
    },
    linkPrefix: {
      type: String,
      default() {
        return '/'
      }
    },
    type: {
      type: String,
      default() {
        return 'classes'
      }
    }
  },
  data() {
    return {
      selectedIndex: 0,
      heightBody: 0
    }
  },
  computed: {
    isEmptySchools() {
      return _.isEmpty(this.schools)
    }
  },
  watch: {
    schools: {
      deep: true,
      handler() {
        this.selectedIndex = 0
        this.$nextTick(() => {
          const schoolDivs = document.getElementsByClassName('map-school-card-body__school')
          this.heightBody = schoolDivs.length ? `${_.maxBy(schoolDivs, 'offsetHeight').offsetHeight}px` : 0
        })
      }
    }
  },
  methods: {
    nextSchool() {
      if (this.schools && this.schools.id && this.selectedIndex < this.schools.id.length - 1) {
        this.selectedIndex += 1
      }
    },
    previousSchool() {
      if (this.selectedIndex > 0) {
        this.selectedIndex -= 1
      }
    }
  }
}
</script>

<style scoped>
.map-school-card {
  width: 350px;
  background: #FFFFFF;
  padding: 18px 16px 16px 16px;
  box-shadow: 0 16px 24px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.04),
    0 0 1px rgba(0, 0, 0, 0.04);
}
.map-school-card-hr {
  background: #E8EDF1;
  margin: 8px 0 12px 0;
}
.map-school-card-header__city {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 16px;
  color: #4F4F4F;
  margin-left: 6px;
  margin-top: 3px;
}
.map-school-card-body__title {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #0078C1;
}
.map-school-card-body__address {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #4F4F4F;
  margin-top: 6px;
}
.map-school-card-body__org {
  margin-top: 12px;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #4F4F4F;
}
.hidden-school {
  visibility: hidden;
  order: 2;
}
.current-school {
  order: 1;
}
.map-school-card-body__title:hover,
.map-school-card-body__org-site:hover {
  text-decoration: none;
  color: #10547D;
}
</style>
